import { gql } from '@apollo/client'

export const MODIFY_RATE_PLAN_MUTATION = gql`
  mutation ModifyRatePlan(
    $input: RatePlanInput!
    $propertyCode: String!
    $roomTypeCode: String!
    $ratePlanCode: String!
  ) {
    modifyRatePlan(
      input: $input
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      ratePlanCode: $ratePlanCode
    ) {
      message
    }
  }
`

export const MODIFY_RATE_PLAN_ACTIVE_MUTATION = gql`
  mutation ModifyActiveRatePlan(
    $propertyCode: String!
    $roomTypeCode: String!
    $ratePlanCode: String!
    $active: Boolean!
  ) {
    modifyActiveRatePlan(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      ratePlanCode: $ratePlanCode
      active: $active
    ) {
      message
    }
  }
`
